import {
  Input as AntdInput,
  Button as AntdButton,
  Alert as AntdAlert,
  Checkbox as AntdCheckbox,
  Form,
} from 'antd'
import styled from '@emotion/styled'
import Modal from '@/components/common/Modal'

export const Button = styled(AntdButton)``

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    .ant-modal-body {
      padding-top: 0px;
    }
  }
`

export const FormContainer = styled(Form)`
  .ant-form-item {
    margin: 0px;
  }
`

export const Alert = styled(AntdAlert)`
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border: none;
  border-radius: 4px;
`

export const Title = styled('div')`
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  margin: 16px 0px;
`

export const ContainerCheckbox = styled('div')`
  margin-top: 8px;
`

export const Checkbox = styled(AntdCheckbox)`
  margin: 8px 0px;
`

export const DetailInput = styled(AntdInput.TextArea)`
  border: 1px solid #e5e5e5;
  border-radius: 8px;

  .ant-input-data-count {
    font-size: 12px;
    font-weight: 400;
    color: #666666;
  }
`
export const Line = styled('div')`
  background: #e5e5e5;
  margin: 25px 0px;
  height: 1px;
`

export const FormItemCheckBox = styled(Form.Item)``

export const FormItemInput = styled(Form.Item)`
  padding-left: 24px;
`

export const FormItem = styled(Form.Item)`
  label {
    font-weight: 500;
    font-size: 14px;
    color: #000000;
  }
`

export const PhoneInput = styled(AntdInput)`
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  width: 50%;
`
